<template>
  <div v-bind:class="{'col-12': !$parent.meeting_view }">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <h4 class="card-title text-muted">{{ $t("KPI") }}</h4>
            <h3 class="font-bold">{{ kpiData.name}}</h3>
            <h6 class="m-b-15" v-if="!calculatedKpi">{{ $t("Last performance")}}</h6>
            <h6 class="m-b-15" v-else>{{ $t("Current performance") }}</h6>
            <h6 class="text-muted" v-if="kpiData.last_performance === false">{{ $t("Not available") }}</h6>
          </div>
        </div>
        <div class="last-performance-div">

          <div class="text-left">

            <h4 class="text-big" v-if="kpiData.last_performance !== false" v-bind:class="[ kpiData.last_performance.target_met === 0 ? 'text-danger' : 'text-success']">{{ kpiData.last_performance.value | formatNumber }}</h4>
            <div v-if="kpiData.last_performance !== false">
              <span v-if="kpiData.last_performance.target || kpiData.last_performance.target === 0">/{{ kpiData.last_performance.target | formatNumber }} {{ kpiData.last_performance.unit }} / {{ kpiData.last_performance.period }}</span>
              <span v-else>{{ kpiData.last_performance.unit }}</span>
              <span v-bind:class="[ kpiData.last_performance.target_met === 0 ? 'text-danger' : 'text-success']">{{ kpiData.unit }}</span>
              <br>
              <h6 class="text-muted" v-if="!calculatedKpi">Reg. {{ kpiData.last_performance.timestamp | formatDate }}</h6>
              <h6 class="text-muted" v-if="calculatedKpi">{{ $t("To date")}}</h6>
            </div>
          </div>

          <div class="progress m-t-15 m-b-15" v-if="kpiData.last_performance !== false">

            <div class="progress-bar" role="progressbar" style="height: 6px;" v-bind:class="[ kpiData.last_performance.target_met === 0 ? 'bg-danger' : 'bg-success']"
                 v-bind:style="{ width: barWidth + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <span class="text-info d-none d-sm-block">
            <a class="overrule" id="onresponsive-modal" href="#" @click="detailsModal = true"><i class="ti-plus"></i>{{ $t("Details")}}</a>
          </span>

        </div>
      </div>
    </div>

    <!--==========================================================================-->
    <!-- The modals for this widget                                               -->
    <!--==========================================================================-->
    <kpi-details-modal v-if="detailsModal" :kpiId="kpiData.uid" :key="kpiData.uid"></kpi-details-modal>

    <report-problem-modal v-if="problemModal" :kpi_units="{'unit':kpiData.last_performance === false ? null : kpiData.last_performance.unit, 'period': kpiData.last_performance === false ? null : kpiData.last_performance.period}" :kpi_name="kpiData.name" :kpi_uid="kpiData.uid" @close="problemModal = !problemModal"></report-problem-modal>
    <set-target-modal v-if="targetModal" :kpi_units="{'unit': kpiData.last_performance === false ? null : kpiData.last_performance.unit, 'period': kpiData.last_performance === false ? null : kpiData.last_performance.period}" :kpi_name="kpiData.name" :kpi_uid="kpiData.uid" :change_able="kpiData.can_change_target" @close="targetModal = false"></set-target-modal>
  </div>

</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  import ReportProblemModal from "./ReportProblemModal";
  import SetTargetModal from "./SetTargetModal";
  import RelatedKpiRow from "./RelatedKpiRow";
  import KpiDetailsModal from "./KpiDetailsModal";
  import ProblemTableRow from "./ProblemTableRow";

  export default {
    props: ["kpiData"],
    name: "kpi-widget",
    components: {
      ProblemTableRow,
      RelatedKpiRow,
      "report-problem-modal": ReportProblemModal,
      "set-target-modal": SetTargetModal,
      KpiDetailsModal
    },
    data: function () {
      return {
        targetModal: false,
        problemModal: false,
        detailsModal: false,
        canChangeTarget: false,
        dataLoaded: false,
        calculatedKpi: false,
        currentUserId: localStorage.getItem("user_uid"),
        modalId: "",
        moment: moment,
        performanceRange: {
          start: moment().subtract(1, "month"),
          end: moment(),
          timeunit: "week"
        },
        problemRange: {
          start: moment().subtract(1, "month"),
          end: moment(),
          criterium: "loss"
        },
        performanceData: {},
        actionData: [],
        actionsPaginationSettings: {
          totalPages:0,
          currentPage: 0
        },
        kpiWidgetModals: [],
        problemData: {},
        relatedKPIData: {},
        problemChartData: {
          loaded: false,
          labels: [],
          dataSets: [
            {
              yAxisID: "barAxis"
            }, // The bar data set
            {
              data: [],
              yAxisID: "lineAxis",
              type: "line",
              lineTension: 0,
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderColor: "#2a78e4",
              pointStyle: "circle"
            }
          ],
          options: {
            scales: {
              yAxes: [
                {
                  id: "barAxis",
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                },
                {
                  id: "lineAxis",
                  ticks: {
                    display: false,
                    beginAtZero: true
                  },
                  gridLines: {
                    display: false
                  }
                }],
              xAxes: [{
                stacked: true
              }]

            },
            responsive: true,
            maintainAspectRatio: true,
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltips: {
              display: false
            }
          }
        },
        relatedKPIIDArray: [],
        performanceChartData: {
          loaded: false,
          labels: [],
          dataSets: [
            { // The target line data
              data: [],
              type: "line",
              lineTension: 0,
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderColor: "#2a78e4",
              pointStyle: "circle"
            },
            // The value data set
            {
              backgroundColor: []
            }
          ],
          options: {
            scales: {
              yAxes: [{
                stacked: true,
                startAtZero: false
              }],
              xAxes: [{
                stacked: true
              }]

            },
            responsive: true,
            maintainAspectRatio: true,
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltips: {
              display: false
            }
          }
        },
        cumulative: {},
        activeTab: "performance"
      }
    },
    created(){
      let vm = this;
      if (this.kpiData.last_performance !== false) {
        this.performanceRange = this.setPeriods(this.kpiData.last_performance.period);
        this.problemRange = this.setPeriods(this.kpiData.last_performance.period);
      }
      this.kpiId = this.kpiData.uid;
      this.loadData(this.kpiId);
      this.modalId = Array(16).join((Math.random().toString(36)+'00000000000000000').slice(2, 18)).slice(0, 16);
      this.$on('closeModal', function (data) {
        for(let modal of vm.kpiWidgetModals){
          if(modal.id === data){
            modal.open = false;
          }
        }
      });

      this.$root.$on('openModal', function (data) {
        vm.openModal(data);
      });

    },
    mounted(){

    },
    methods: {
      parseRelatedKpis(related){
        if(typeof related.children === "undefined"){
          this.kpiWidgetModals.push({id: related.uid, open: false});
        }else{
          this.kpiWidgetModals.push({id: related.uid, open: false});
          for(let child in related.children){
            this.parseRelatedKpis(related.children[child]);
          }
        }
      },
      getTimePeriods: function(kpiTimePeriod){
        let timePeriods = ["year", "4weeks", "month", "week", "day"];
        if (typeof kpiTimePeriod !== 'undefined') {
          return timePeriods.slice(0, timePeriods.indexOf(kpiTimePeriod) + 1);
        } else {
          return timePeriods;
        }
      },
      ucFirst: function(text){
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      setPeriods: function(timeunit) {
        switch (timeunit){
          case "day":
            return {
              start: moment().subtract(1, "week"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "week":
            return {
              start: moment().subtract(2, "month"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "month":
            return {
              start: moment().subtract(1, "year"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
        case "4weeks":
          return {
            start: moment().subtract(1, "year"),
            end: moment(),
            timeunit: timeunit,
            criterium: "loss"
          };
          case "year":
            return {
              start: moment().subtract(5, "year"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
        }
      },
      openModal(id){
        for(let modal of this.kpiWidgetModals){
          if(modal.id === id){
            modal.open = true;
          }
        }
      },
      loadData: function (id) {
        let vm = this;
        let date_range = "";
        date_range = "date_start=" + moment(this.performanceRange.start).format("YYYY-MM-DD");
        date_range += "&date_end=" + moment(this.performanceRange.end).format("YYYY-MM-DD");
        date_range += "&time_unit=" + this.performanceRange.timeunit;
        APIHelper
          .getResource("/api/kpi/" + id + "/widget?" + date_range)
          .then(function (data) {
            if (data.kpi.addup_type !== null && data.kpi.addup_type !== false){
              vm.calculatedKpi = true;
            }
            vm.performanceData = data.performances;
            vm.actionData = data.actions;
            // Generate the icon data
            for (let i = 0; i < vm.actionData.length; i++) {
              vm.actionData[i].icon = vm.actionData[i].status;
            }
            vm.dataLoaded = true;
            vm.problemData = data.problems;
            // Add the expension state
            for (let i = 0; i < vm.problemData.length; i++) {
              vm.problemData[i].expanded = false;
            }
            vm.relatedKPIData = data.dependencies;
            vm.canChangeTarget = data.kpi.can_change_target === 1;
            vm.getProblemsForKpi();
            vm.getPerformanceGraphData();
            vm.getRelatedKpiData();
            vm.cumulative = data.cumulative[Object.keys(data.cumulative)[0]];
            vm.performanceChartData.loaded = true;
            vm.problemChartData.loaded = true;
          });
      },
      date_picked(response){
        if (response !== null) {
          this.performanceRange.start = response.startDate;
          this.performanceRange.end = response.endDate;
          this.performanceChartData.loaded = false;
          this.problemChartData.loaded = false;
          this.loadData(this.kpiId);
        }
      },
      period_changed(){
        this.performanceChartData.loaded = false;
        this.problemChartData.loaded = false;
        this.loadData(this.kpiId);
      },
      getProblemsForKpi: function () {
        let vm = this;
        let barArray = [];
        let lineArray = [];
        let labelsArray = [];
        let i = 0; // keep track of the current array index
        if (this.problemRange.criterium === "loss") {
          for (let problem of vm.problemData) {
            let arrayMax = Math.max.apply(Math, vm.problemData.map((o) => {
              return o.loss;
            }));

            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = arrayMax;

            barArray.push(problem.loss);
            labelsArray.push(problem.name);
            // If it is the first item, push only the loss of this problem, otherwise add it to the previous and push it
            lineArray.push(lineArray[i - 1] === undefined ? (arrayMax * (parseInt(problem.loss_percentage) / 100)) : lineArray[i - 1] + (arrayMax * (parseInt(problem.loss_percentage) / 100)));
            i++;
          }
        } else if (this.problemRange.criterium === "loss_percentage") {
          if (vm.problemData.length > 0) {
            let percentageSum = vm.problemData.reduce((a, b) => {
              return parseInt(a.loss_percentage === undefined ? a : a.loss_percentage) + parseInt(b.loss_percentage)
            });

            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = percentageSum;

            for (let problem of vm.problemData) {
              barArray.push(problem.loss_percentage);
              labelsArray.push(problem.name);
              lineArray.push(lineArray[i - 1] === undefined ? parseInt((parseInt(problem.loss_percentage) / percentageSum) * 100) : parseInt((lineArray[i - 1] + (parseInt(problem.loss_percentage) / percentageSum) * 100)));
              i++;
            }
          }
        } else {
          for (let problem of vm.problemData) {
            let frequencySum = vm.problemData.reduce((a, b) => {
              return parseInt(a.frequency === undefined ? a : a.frequency) + parseInt(b.frequency)
            });
            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = frequencySum;
            barArray.push(problem.frequency);
            labelsArray.push(problem.name);
            // If it is the first item, push only the loss of this problem, otherwise add it to the previous and push it
            lineArray.push(lineArray[i - 1] === undefined ? parseInt(problem.frequency) : lineArray[i - 1] + parseInt(problem.frequency));
            i++;
          }
        }
        vm.problemChartData.dataSets[0].data = barArray;
        vm.problemChartData.dataSets[1].data = lineArray;
        vm.problemChartData.labels = labelsArray;
        vm.problemChartData.loaded = true;
      },
      getPerformanceGraphData(){
        let vm = this;
        vm.performanceChartData.loaded = false;
        // Split the data points for the KPI into the value, shortage and surplus
        let valueArray = [];
        let targetArray = [];
        let colorArray = [];
        let labelsArray = [];
        for(let key in vm.performanceData){
          if (vm.performanceData[key].target || vm.performanceData[key].target === 0) {
            valueArray.push(vm.performanceData[key].performance);
            targetArray.push(vm.performanceData[key].target);

            if (parseInt(vm.performanceData[key].target_met) === 1) {
              colorArray.push("#8cc63e");
            }else{
              colorArray.push("#dc3545");
            }

          }else if(vm.performanceData[key].performance || vm.performanceData[key].performance === 0){
            valueArray.push(vm.performanceData[key].performance);
          }
          labelsArray.push(moment(vm.performanceData[key].date_start).format("MMMM Do"))
        }
        vm.performanceChartData.labels = labelsArray;
        vm.performanceChartData.dataSets[1].data = valueArray;
        vm.performanceChartData.dataSets[0].data = targetArray;
        vm.performanceChartData.dataSets[1].backgroundColor = colorArray;
        vm.performanceChartData.loaded = true;
      },
      getRelatedKpiData(){
        for(let child in this.relatedKPIData){
          this.parseRelatedKpis(this.relatedKPIData[child]);
        }
      },
      iconFormatter: function (value, rowProperties) {
        let icon = "";

        switch (value) {
          case 'done':
            icon = '<i class="ti-check text-success"></i>';
            break;
          case 'accept':
            icon = '<i class="ti-more-alt text-info"></i>';
            break;
          case 'declined':
            icon = '<i class="ti-close text-danger"></i>';
            break;
          case 'pending':
            icon = '<i class="ti-settings text-info"></i>';
            break;
        }

        return icon;
      },

      fetchActionsData: function ({page, filter, sort}) {
        let PAGE_AMOUNT = 5;
        this.actionsPaginationSettings.totalPages = Math.ceil(this.actionData.length / PAGE_AMOUNT);
        this.actionsPaginationSettings.currentPage = page;
        let pageData = this.actionData.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);

        let paginationData = {
          totalPages: this.actionsPaginationSettings.totalPages,
          currentPage: page
        };

        pageData = pageData.sort(this.sortByProperty(sort.fieldName, sort.order));
        return { data: pageData, pagination: paginationData}
      },

      sortByProperty(property, direction) {
        let directionCoeff = direction === "asc" ? 1 : -1;

        return function (a, b) {
          let sortA = (a[property] === null || typeof a[property] === 'undefined') ? a[property] : a[property].toLowerCase();
          let sortB = (b[property] === null || typeof b[property] === 'undefined') ? b[property] : b[property].toLowerCase();

          if (sortA < sortB) {
            return -1 * directionCoeff;
          }

          if (sortA > sortB) {
            return directionCoeff;
          }
          return 0;
        }
      },
    },
    computed: {
      barWidth: {
        // Set the bar width to either 100% or the percentage it should be filled
        get () { return Math.min(( this.kpiData.last_performance.value / this.kpiData.last_performance.target) * 100, 100) },
        set(value){ }
      }
    }
  }
</script>

<style scoped>
  .card-body {
    min-height: 275px;
  }

  h4 {
    margin-bottom: 1rem;
  }
</style>

<style>
  .card-body{
    flex-direction: column;
    display: flex;
    justify-content: space-between;
  }
  .last-performance-div{
    align-self: flex-end;
    width: 100%;
  }

  .table-component__table__body > tr > td, .problems-table > .table-row{
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
  }

  .table-component__table__body > tr > td > i{
    font-size: 20px;
  }

  .problems-table > .table-row:nth-child(even), .table-component__table__body > tr:nth-child(even){
    background-color: #f5f7fb;
  }
  .pagination .chevron{
    margin-top: 1.5rem;
  }
  .table-row{
    padding-left: 10px;
  }

  .meeting-row{
    margin-left: 50px;
  }

  .graph-div{
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-data-div{
    padding: 10px 20px;
    height: 50px;
    border-radius: 30px;
    display: inline-flex;
    justify-content:center;
    align-items:center;
    background-color: #f4f1f2;
    border: 1px solid #c3c3c3;
  }
  .loading-data-div > img{
    margin-right: 8px;
  }

  .loading-data-div > span{
    color: #67757c;
  }

</style>



// WEBPACK FOOTER //
// src/components/KPIWidget.vue